import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';
import { DatabaseIndice } from '../alcance/interfaces/database';

export type UploadQueueStatus = 'pending' | 'uploading' | 'done' | 'error';

export interface UploadQueueItem {
    uuid: string;
    owner_uuid: string;
    owner_table: string;
    field: string;
    path: string;
    filename?: string;
    mime_type?: string;
    status: UploadQueueStatus;
    server_path?: string;
    server_id?: number;
    error?: string;
    attempts?: number;
    last_status?: number;
    last_attempt_at?: string;
    next_retry_at?: string;
    metadata?: any;
}

@Injectable({
    providedIn: 'root'
})
export class UploadQueueDBService extends DatabaseService {
    override classname: string = 'UploadQueueDBService';
    override table = 'upload_queue';
    override keyPath = 'uuid';
    override typeKey = 'TEXT';
    protected override useUuidKey = true;

    override indices: DatabaseIndice[] = [
        {name: 'by_owner_uuid', field: 'owner_uuid', unique: false, multiEntry: false},
        {name: 'by_status', field: 'status', unique: false, multiEntry: false},
        {name: 'by_table', field: 'owner_table', unique: false, multiEntry: false},
    ];

    protected override filterSql(sql: string, params: any): string {
        if(params?.status){
            sql += sql.indexOf('WHERE') == -1 ? ' WHERE' : ' AND';
            sql += " by_status = '" + params.status + "'";
        }

        if(params?.owner_uuid){
            sql += sql.indexOf('WHERE') == -1 ? ' WHERE' : ' AND';
            sql += " by_owner_uuid = '" + params.owner_uuid + "'";
        }

        if(params?.owner_table){
            sql += sql.indexOf('WHERE') == -1 ? ' WHERE' : ' AND';
            sql += " by_table = '" + params.owner_table + "'";
        }

        return sql;
    }
}
